import { render, staticRenderFns } from "./Vivienda.vue?vue&type=template&id=5deaa8b8&scoped=true&"
import script from "./Vivienda.vue?vue&type=script&lang=js&"
export * from "./Vivienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deaa8b8",
  null
  
)

export default component.exports